import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { regulatoryUpdatesKeys } from './keys';
import { IRegulatoryUpdateListResponse } from './types';

export interface RegulatoryUpdatesQueryParams {
  regions?: string[];
  regimes?: string[];
  severities?: string[];
  states?: string[];
  sourceClasses?: string[];
  search?: string;
  limit?: number;
  offset?: number;
}

const getRegulatoryUpdates = async (params: RegulatoryUpdatesQueryParams) => {
  const queryParams = new URLSearchParams();
  if (params.regions?.length)
    queryParams.append('regions', params.regions.join(','));
  if (params.regimes?.length)
    queryParams.append('regimes', params.regimes.join(','));
  if (params.severities?.length)
    queryParams.append('severities', params.severities.join(','));
  if (params.states?.length)
    queryParams.append('states', params.states.join(','));
  if (params.sourceClasses?.length)
    queryParams.append('sourceClasses', params.sourceClasses.join(','));
  if (params.search) queryParams.append('search', params.search);
  if (params.limit !== undefined)
    queryParams.append('limit', String(params.limit));
  if (params.offset !== undefined)
    queryParams.append('offset', String(params.offset));

  const queryString = queryParams.toString();

  const url = `regulatory-updates${queryString ? `?${queryString}` : ''}`;

  const response = await fetcher(url, { method: 'GET' });

  if (!response.ok) throw new Error('Failed to fetch regulatory updates');

  return (await response.json()) as IRegulatoryUpdateListResponse;
};

export const useRegulatoryUpdates = (
  params: RegulatoryUpdatesQueryParams = {}
) => {
  return useQuery({
    queryKey: [
      regulatoryUpdatesKeys.LIST,
      params.regions,
      params.regimes,
      params.severities,
      params.states,
      params.sourceClasses,
      params.search,
      params.limit,
      params.offset,
    ],
    queryFn: () => getRegulatoryUpdates(params),
  });
};
